export default "__VITE_ASSET__DU96v3oa__"